import React from 'react';
import { Link } from 'react-router-dom';
import './weatherDetails.css';

/**
 * Breadcrumb : Trip > Check Claims > Weather Details
 */
const WeatherBreadcrumb = () => (
    <nav className="wd-breadcrumb wd-no-print" aria-label="Fil d'Ariane">
        <Link to="/admin/trips/daily">Trip</Link>
        <span className="wd-breadcrumb__sep" aria-hidden="true">›</span>
        <Link to="/admin/trips/check-claims">Check Claims</Link>
        <span className="wd-breadcrumb__sep" aria-hidden="true">›</span>
        <span className="wd-breadcrumb__current" aria-current="page">Weather Details</span>
    </nav>
);

export default WeatherBreadcrumb;
